import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

// 创建 Vuex store
const store = new Vuex.Store({
	state: {
		user: {
			id: '',
			avatar: '',
			user_nickname: '',
		},
		shopStatus: localStorage.getItem('shopStatus')
	},
	mutations: {
		// 设置用户信息
		setUser(state, userData) {
			state.user = userData;
			localStorage.setItem('token', userData.token); // 可选，存储 token
		},
		SET_SHOP_STATUS(state, status) {
			state.shopStatus = status
			localStorage.setItem('shopStatus', status) // 同步到 localStorage
		},
		// 清除用户信息
		logout(state) {
			state.user = {
				id: '',
				avatar: '',
				user_nickname: ''
			};
			localStorage.removeItem('token'); // 可选，移除 token
		}
	},
	actions: {
		// 登录操作
		login({
			commit
		}, userData) {
			commit('setUser', userData);
		},
		updateShopStatus({
			commit
		}, status) {
			commit('SET_SHOP_STATUS', status)
		},
		// 登出操作
		logout({
			commit
		}) {
			commit('logout');
		}
	},
	getters: {
		// 获取用户信息
		getUser(state) {
			return state.user;
		},
		// 判断是否登录
		isLoggedIn(state) {
			return !!state.user.token;
		}
	}
});

export default store;